import { type ReactNode } from 'react';
import { useThemeInjector } from '@/domains/settings/hooks/useThemeInjector.js';

export function ThemeProvider({ children }: { children: ReactNode }) {
    useThemeInjector();
    return <>{children}</>;
}
